import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ProfileTabs from './components/ProfileTabs';

const Calendar = () => (
  <Container>
    <div className="profile">
      <Row>
        <Col md={12} lg={12} xl={12}>
          <Row>
            <ProfileTabs />
          </Row>
        </Col>
      </Row>
    </div>
  </Container>
);

export default Calendar;
